
  import {
    mapGetters,
    mapState
  } from "vuex";

  import {
    GET_AMENITIES,
  } from '~/store/amenities/constants';

  import search from "@/mixins/search";

  export default {
    name: "ModalFilters",
    mixins: [
      search
    ],
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isOpen: false,
      };
    },
    created() {
      this.$store.dispatch(GET_AMENITIES);
    },
    methods: {
      close() {
        this.$emit("close");
      },
      clear() {
        this.filters.amenities = [];
        this.action();
      },
      action() {
        this.submitSearch({
          data: true,
          redirect: 'properties'
        });
        this.close();
      }
    },
    computed: {
      ...mapState({
        amenities: state => state.amenities.getAmenitiesRequest.data,
      }),
      ...mapGetters({
        translations: "locales/translations",
      }),
    },
    watch: {
      show(newVal) {
        this.initFilters();
        this.isOpen = newVal;
      },
    }
  };
